// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconsLoader_icon__UxgPF","shimmer":"IconsLoader_shimmer__7c1pS"};